import {
    SearchActionsEventType,
    SearchEntityActionsEventType,
    EntityActionTakenType,
    GroupLayoutType,
} from '../data/schema/substrateSearchLogTypes';
import ResultsView from '../data/schema/ResultsView';
import { getLocalTime } from 'owa-search-service/lib/helpers/getLocalTime';
import SubstrateEvent from 'owa-search-service/lib/data/schema/SubstrateEvent';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import substrateSearchLogEventsOperation from 'owa-search-service/lib/services/substrateSearchPostEventsService';
import { addLocalTimeAttribute } from '../helpers/addLocalTimeAttribute';
import { ClientDataSourceEvent } from '../data/schema/ClientDataSourceEvent';

export function logResponseReceived(
    substrateSearchScenario: SubstrateSearchScenario,
    traceId: string,
    latency: number,
    status: number | string | undefined
) {
    const event: SubstrateEvent = {
        Name: 'responsereceived',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'traceId', Value: traceId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'latency', Value: latency.toString() },
            { Key: 'status', Value: status?.toString() },
        ],
    };

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logCachedContentRendered(
    substrateSearchScenario: SubstrateSearchScenario,
    userId: string,
    tenantId: string,
    logicalId: string,
    newLogicalId: string,
    conversationId: string,
    traceId: string
) {
    const event: SubstrateEvent = {
        Name: 'cachedcontentrendered',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'userid', Value: userId },
            { Key: 'tenantid', Value: tenantId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'newlogicalid', Value: newLogicalId },
            { Key: 'conversationid', Value: conversationId },
        ],
    };

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logResultsRendered(
    substrateSearchScenario: SubstrateSearchScenario,
    logicalId: string,
    traceId: string,
    e2eLatency: number
) {
    const event: SubstrateEvent = {
        Name: 'resultsrendered',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'traceId', Value: traceId },
            { Key: 'e2elatency', Value: e2eLatency.toString() },
        ],
    };

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logClientDataSource(
    substrateSearchScenario: SubstrateSearchScenario,
    clientDataSourceEvent: ClientDataSourceEvent
) {
    const event: SubstrateEvent = {
        Name: 'clientdatasource',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'userid', Value: clientDataSourceEvent.userId },
            { Key: 'tenantid', Value: clientDataSourceEvent.tenantId },
            { Key: 'logicalid', Value: clientDataSourceEvent.logicalId },
            { Key: 'traceId', Value: clientDataSourceEvent.traceId },
            { Key: 'providername', Value: clientDataSourceEvent.providerName },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'impressiontype', Value: clientDataSourceEvent.impressionType },
            { Key: 'results', Value: JSON.stringify(clientDataSourceEvent.results) },
        ],
    };

    substrateSearchLogEventsOperation(
        clientDataSourceEvent.traceId,
        event,
        substrateSearchScenario
    );
}

export function logClientLayout(
    substrateSearchScenario: SubstrateSearchScenario,
    userId: string,
    tenantId: string,
    logicalId: string,
    traceId: string,
    layoutType: GroupLayoutType,
    resultsView: ResultsView[]
) {
    const event: SubstrateEvent = {
        Name: 'clientlayout',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'userid', Value: userId },
            { Key: 'tenantid', Value: tenantId },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'layouttype', Value: layoutType },
            { Key: 'resultsview', Value: JSON.stringify(resultsView) },
        ],
    };

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logSearchActions(
    substrateSearchScenario: SubstrateSearchScenario,
    userId: string,
    tenantId: string,
    logicalId: string,
    traceId: string,
    searchActionEventType: SearchActionsEventType
) {
    const event: SubstrateEvent = {
        Name: 'searchactions',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'userid', Value: userId },
            { Key: 'tenantid', Value: tenantId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'traceid', Value: traceId },
            { Key: 'eventType', Value: searchActionEventType },
        ],
    };

    substrateSearchLogEventsOperation(logicalId, event, substrateSearchScenario);
}

export function logSearchEntityActions(
    substrateSearchScenario: SubstrateSearchScenario,
    userId: string,
    tenantId: string,
    logicalId: string,
    traceId: string,
    referenceId: string,
    eventType: SearchEntityActionsEventType,
    metadata?: Map<string, string>
) {
    const event: SubstrateEvent = {
        Name: 'searchentityactions',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'userid', Value: userId },
            { Key: 'tenantid', Value: tenantId },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'traceId', Value: traceId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'id', Value: referenceId },
            { Key: 'eventtype', Value: eventType },
        ],
    };

    if (metadata) {
        let metaDataValue: any[] = [];
        metadata.forEach((value, key) => {
            metaDataValue.push({ Key: key, Value: value });
        });
        event.Attributes.push({
            Key: 'metadata',
            Value: JSON.stringify(metaDataValue),
        });
    }

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logSecondaryEntityActionClicked(
    currentTime: Date,
    traceId: string,
    referenceId: string,
    eventType: SearchEntityActionsEventType,
    substrateSearchScenario: SubstrateSearchScenario,
    entityActionTaken: EntityActionTakenType
) {
    logSearchEntityActions(
        substrateSearchScenario,
        null,
        null,
        null,
        traceId,
        referenceId,
        eventType,
        new Map<string, string>([['entityactiontaken', entityActionTaken]])
    );
}

export function logFeedback(
    currentTime: Date,
    traceId: string,
    yesSelected: boolean,
    feedbackString: string,
    substrateSearchScenario: SubstrateSearchScenario
) {
    const event: SubstrateEvent = { Name: 'SearchFeedback', Attributes: [] };
    event.Attributes.push({ Key: 'TraceId', Value: traceId });
    addLocalTimeAttribute(event, currentTime);
    event.Attributes.push({ Key: 'Version', Value: '2' });

    const feedbackResponse = {
        Type: 'ResultFoundResponse',
        ResponseValue: yesSelected ? 'Yes' : 'No',
        FeedbackString: feedbackString,
    };

    event.Attributes.push({ Key: 'FeedbackResponse', Value: JSON.stringify(feedbackResponse) });

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}

export function logSearchFeedbackActions(
    substrateSearchScenario: SubstrateSearchScenario,
    logicalId: string,
    traceId: string,
    referenceId: string,
    feedbackresponse: string
) {
    const event: SubstrateEvent = {
        Name: 'searchfeedback',
        Attributes: [
            { Key: 'version', Value: '2' },
            { Key: 'logicalid', Value: logicalId },
            { Key: 'localtime', Value: getLocalTime() },
            { Key: 'id', Value: referenceId },
            { Key: 'feedbackresponse', Value: feedbackresponse },
        ],
    };

    substrateSearchLogEventsOperation(traceId, event, substrateSearchScenario);
}
